<button class="btn" (click)="cancel(ticket.messageThread)">{{ 'cancel' | translate }}</button>

<div class="d-flex">
    @if (ticket.constraints.isBulkReplyHidingAllowed) {
        <button class="btn me-3" (click)="changeRepliesVisibility(true)" [disabled]="isSending">
            <i class="far fa-eye me-1"></i>
            {{ 'show' | translate }}
        </button>
        <button class="btn" (click)="changeRepliesVisibility(false)" [disabled]="isSending">
            <i class="far fa-eye-slash me-1"></i>
            {{ 'hide' | translate }}
        </button>
    }
</div>

@if (ticket.constraints.isBulkReplyDeletionAllowed) {
    <button class="btn" (click)="openDeleteModal()" [disabled]="isSending">
        <i class="fas fa-trash-alt me-1"></i>
        {{ 'delete' | translate }}
    </button>
}
